<template>
  <div class="container">
    <div id="title-of-save">
      <h1 id="title-text-child">
        Receive SMS - QuickGuide
      </h1>
    </div>
    <div class="row margin-bottom-2">
      <div class="col">
        <h2>Dashboard</h2>
        On the landing page, navigate to the menu item "Inbox".<br/>
        <br/>
        <img src="~@/assets/receivesms/receivesms-header.png" class="col-xs-6"/><br/>
        <br/>
        Your subscriptions for ReceiveSMS are listed, if you have more than one, you have to choose one.<br/>
        After chosed an Application your Receive Number will be shown and you can select an inbox.<br/>
        <br/>
        <img src="~@/assets/receivesms/receivesms-reply-number.png" class="col-xs-6"/><br/>
        <br/>
        After clicking on a inbox you can see all the message in it.<br/>
        <br/>
        <img src="~@/assets/receivesms/receivesms-inbox.png" class="col-xs-9"/><br/>
      </div>
    </div>
    <hr>
    <div class="row margin-bottom-2">
      <div class="col">
        <h2>Create Inbox (Shared Reply Number)</h2>
        Inboxes can only be created via API (API documentation)<br/>
        <br/>
        <blockquote  class="apiCode">
        POST https://api.swisscom.com/messaging/sms/inboxes<br/>
          <b>Headers</b><br/>
          &nbsp;- SCS-Version: 2<br/>
          &nbsp;- Authorization: Bearer &lt;access_token&gt;<br/>
          <b>Body</b><br/>
        {<br/>
          &nbsp;&nbsp;"inboxId": "MyInbox"<br/>
        }<br/>
        </blockquote >
      </div>
    </div>
    <hr>
    <div class="row margin-bottom-2">
      <div class="col">
        <h2>Create Inbox (Own Reply Number)</h2>
        You can create as many Inboxes as you want in the same way as for Shared Reply Number<br/>
        <br/>
        But you can create a default Inbox, where all not to inbox assigned SMS will be.<br>
        Just use the keyword <b>"DEFAULT"</b><br/>
        <br/>
        <blockquote  class="apiCode">
          POST https://api.swisscom.com/messaging/sms/inboxes<br/>
          <b>Headers</b><br/>
          &nbsp;- SCS-Version: 2<br/>
          &nbsp;- Authorization: Bearer &lt;access_token&gt;<br/>
          <b>Body</b><br/>
          {<br/>
          &nbsp;&nbsp;"inboxId": "DEFAULT"<br/>
          }<br/>
        </blockquote >
      </div>
    </div>
  </div>
</template>

<script>

</script>

<style scoped>
.apiCode{
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 5px;
  font-family: 'Courier New', Courier, monospace;

}

</style>
